<div class="flex-vertical flex-start gap-24 flex-center justify-center" *ngIf="!isloading">
  <div class="files-container width-100pc" *ngIf="fakeCurrentFile">
    <oui-file-item
      class="width-100pc rounded with-border"
      label="Liste des supports Optimiz Portfolio"
      [file]="fakeCurrentFile"
      (delete)="deleteCurrentFile($event)"
      (fileClick)="onCurrentFileClick($event)"></oui-file-item>
  </div>
  <ng-container *ngIf="!fakeCurrentFile">
    <oui-file-uploader
      *ngIf="!toUploadfiles || toUploadfiles.length < 1"
      class="width-100pc"
      type="single"
      accept=".pdf"
      [(value)]="toUploadfiles"
      [control]="fileControl"
      [maxFileSize]="5"
      hint="Fichiers supportés : pdf / Taille max : 5 Mo"
      (valueChange)="onFileChange($event)">
    </oui-file-uploader>
  </ng-container>
</div>
<div class="flex-horizontal flex-center justify-center">
  <oui-loading *ngIf="isloading"></oui-loading>
</div>
